import ModuleBreadCrumb from "../../components/breadCrumb";
import ModuleTitle from "../../components/common/title";
import ModuleCard from "../../components/common/card";

import ImgSetting from "../../images/common/setting.png";
import ImgRecord from "../../images/common/record.png";
import ImgInformation from "../../images/common/information.png";
import ImgWork from "../../images/common/work.png";
import ImgQA from "../../images/common/qa.png";

export default function MemberMain() {
  const crumbItem = [{ key: 1, label: "首頁" }];
  const cardData = [
    {
      title: "功課表",
      img: ImgWork,
      url: "/member/work",
    },
    { title: "知識", img: ImgInformation, url: "/member/knowledge" },
    {
      title: "記錄",
      img: ImgRecord,
      url: "/member/record",
    },
    { title: "常見問題", img: ImgQA, url: "/member/qa" },
    { title: "系統相關", img: ImgSetting, url: "/member/setting" },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "長庚護心" }} />

      <ModuleCard data={cardData} />
    </>
  );
}
